import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { CashDrawerSession, CashDrawerSessionCreate, CashDrawerSessionFilter } from '../data/cashDrawerSession';

export function createCashDrawerSessionService(client: AxiosInstance) {
  return createCrudService<CashDrawerSession, CashDrawerSessionCreate, CashDrawerSessionFilter>(
    client,
    '/restaurant/CashDrawerSession',
    'id',
  );
}

export type CashDrawerSessionService = CrudService<CashDrawerSession, CashDrawerSessionCreate, CashDrawerSessionFilter>;
